module.exports = __webpack_public_path__ + "img/huanjing.9e65922d.jpg";